// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-actions.classic.js, новая — rack-actions.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-actions.classic';
import * as cp from './rack-actions.cp';

export const RackActions = isCp ? cp.RackActions : classic.RackActions;
